// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--2K3En","kicker":"index-module--kicker--8A_Zn"};